'use client';
import { useRouter } from 'next/router';
import { NavbarShared } from './NavbarShared';

export const NavbarPages = () => {
    const router = useRouter();

    const handleSearch = (term: string) => {
        router.push('/search/' + encodeURIComponent(term), undefined, {
            shallow: true,
            scroll: true
        });
    };

    return <NavbarShared pathname={router.asPath} onSearch={handleSearch} />;
};
